module.exports = __webpack_public_path__ + "media/trailer.0c737319.mp4";